    import React from "react"
    import { Link } from "gatsby"
    import { Flex, Box, Text, MaxWidth } from "@sqymagma/elements"
    import ModDataEs from "./ModDataEs"
    import { theme } from "../../../utils/themeGet"

    export default ({ day, month, title, completePath, week, monthNumber, date, openCalendarMenu }) => {
        const [ dayId ] = completePath.split("#").splice(-1, 1)

        return (
        <Flex bg="ui02"  mb={["16vw", null, 0]} ml={["0%", null, 0]}
            position="relative" width={["100%", null, "100%"]}
        >
            <MaxWidth>
                <Flex flexDirection={["column", null, "row"]}>
                    <Flex
                        width={["auto", null, "50%"]}
                        py={["m", null, 0]}
                        px={["m", null, 0]}
                        justifyContent="flex-start"
                        alignItems="center"
                    >
                        <Flex width={["100%",null,"90%"]} justifyContent="space-between" alignItems="center">
                            <Box  mt="0" width={["100%", null, "50%"]}>
                                <Text id={dayId} as="h2" fontSize={["32px","32px","40px","48px"]} pt="xs" fontWeight="800" lineHeight={1}>
                                    {title}
                                </Text>
                                <Text
                                    as="h4" pb="xs"
                                    fontSize={["12px","14px","16px"]} 
                                    fontWeight="600" caps
                                    color="brand02" opacity=".5"
                                    css={`{ letter-spacing: 2px;} `}
                                >
                                    {week && <p>{week}</p>}
                                </Text>
                            </Box>
                            <CalendarSheet month={month} day={day} openCalendarMenu={openCalendarMenu}/>
                        </Flex>
                    </Flex>
                    <Flex
                        width={["82%", null, "50%"]}
                        justifyContent={["flex-start", null, "flex-end"]}
                        position={["absolute", null, "relative"]}
                        top={["7.5rem", null, 0]}
                        left={["12%",null, 0]}
                        right={["6%", null, 0]}
                    >
                        <Flex
                            width={["100%", null, "90%"]}
                            justifyContent="space-between"
                            alignItems="center"
                        >
                            <ModDataEs date={date} />
                        </Flex>
                    </Flex>
                </Flex>
            </MaxWidth>
        </Flex>
        )
    }


    export const CalendarSheet = ({ month, day, openCalendarMenu }) => (
    <Box>
        {month && day && (
        <Box
            onClick={openCalendarMenu}
            bg="ui01"
            width={["42px", "48px", "56px"]}
            height={["42px", "48px", "56px"]}
            position="relative"
            textAlign="center"
            css={`
            {
                cursor:pointer;
                border: 5px solid ${theme("color.ui07")};
                -moz-border-radius: 10px;
                -webkit-border-radius: 10px;
                border-radius: 10px;

                &:before,
                &:after {
                content: "";
                float: left;
                position: absolute;
                top: -10px;
                width: 8px;
                height: 8px;
                background: #111;
                z-index: 1;
                -moz-border-radius: 3px;
                -webkit-border-radius: 3px;
                border-radius: 3px;
                }
                &:before {
                left: 6px;
                }
                &:after {
                right: 6px;
                }
            }
            `}
        >
            <Box bg="ui07" pb="3px">
            <Text
                as="p"
                caps
                color="brand04"
                fontWeight="700"
                fontSize={["10px", "12px", "14px"]}
                textAlign="center"
                lineHeight={1}
            >
                {month}
            </Text>
            </Box>
            <Text
            as="p"
            color="brand02"
            fontWeight="900"
            fontSize={["19px", "22px", "26px"]}
            textAlign="center"
            lineHeight={1}
            >
            {day}
            </Text>
        </Box>
        )}
    </Box>
    )

